mainApp.directive('hostMonitoringRule', function() {
    return {
        templateUrl: '/public/directives/hostMonitoringRule.html',
        scope: {
            rule: '=',
            lastIndex: '=',
            mailingLists: '=',
            mailingDefinition: '='
        },
        controller:  ['$scope', function($scope) {

            $scope.showConstraint='time';
            $scope.item = $scope.rule;
            $scope.rule.description= $scope.rule.description != null ? $scope.rule.description : ('Host #' + $scope.lastIndex);
            $scope.frequencies = ['IMMEDIATE', 'HOURLY', 'DAILY',  'WEEKLY'];

            //<track-component> uses $scope.id to build it's id.
            //This way we can tell exactly which track popup we want to open when emitting $openPopup
            $scope.id = "_" + $scope.rule.id;



            $scope.config = {
                addConstraints: function() {
                    var item = $scope.rule;
                    item.constraint.predicates = {};

                    if($scope.timeConstraints.type == "always"){
                        delete item.constraint.predicates["time"];
                    }
                    else if($scope.timeConstraints.type == "workingHours"){
                        item.constraint.predicates.time = {"field":{name:"dst_time"},"op":"OP_LE","values":["workingHours"]};
                    }
                    else { //custom
                        item.constraint.predicates.time = {"field":{name:"dst_time"},"op":"OP_LE","values":[$scope.timeConstraints.timeDef]};
                    }

                     $scope.$root.closePopup("constraintEditor-" + $scope.rule.id);
                },
                editConstraints: function(item,id){
                   if(!item.constraint){
                       item.constraint = {"predicates":[],"op":"OP_LE"};
                   }
                   $scope.timeConstraints = {"type":"always","timeDef":{"isA":"Time","days":[],"times":[],"reoccurring":true}};
                   if (item.constraint.predicates["time"]) {
                       item.constraint.predicates["time"].values.forEach(function(value) {
                           if(typeof value == "string"){
                               $scope.timeConstraints.type = value;
                           }
                           else {
                               $scope.timeConstraints.type = "custom";
                               $scope.timeConstraints.timeDef = value;
                           }
                       });
                   }
                   $scope.scopeSelection = {"item":item};
                       $scope.$root.openPopup("constraintEditor-" + $scope.rule.id);
                }
            };

              // Open alert dialog
            $scope.editTrigger = function(){
                $scope.$root.$emit("$openPopup","triggerSelector" + $scope.id,"trigger_" + $scope.rule.id, {topMod: 20, leftMod: -400, simplePosition: true, rightArrow: true});
                var alertFrequency = $scope.rule.alertFrequency?$scope.rule.alertFrequency:"HOURLY";
                var addresses = $scope.rule.addresses?$scope.rule.addresses:"All Admins";
                $scope.scopeSelection = {"item":$scope.rule,"trigger":$scope.rule.trigger,"alertFrequency":alertFrequency,"addresses":addresses};
            };

            $scope.saveTrigger = function(trigger){
                $scope.scopeSelection.item.trigger = $scope.scopeSelection.trigger;
                if($scope.scopeSelection.trigger || trigger) {
                    $scope.scopeSelection.item.alertFrequency = $scope.scopeSelection.alertFrequency;
                    $scope.scopeSelection.item.addresses = $scope.scopeSelection.addresses;
                }
                $scope.$root.$emit("$closePopup","triggerSelector" + $scope.id);
                $scope.$root.$emit("$closePopup","mailingListSelector");
            };
        }]
    }
});
